import { combineReducers } from 'redux';
import CustomizeOrder  from './CustomizeOrder/containers/reducer';
import AddressValidationPage  from './AddressValidationPage/containers/reducer';
import CheckoutPage from './Checkout/containers/reducer';
import OptixCheckoutPage from './OptixCheckout/containers/reducer';
import ReviewOrderPage from './ReviewOrderPage/containers/reducers';
import Confirmation from './Confirmation/containers/reducer';
import SaveCartPage from './SaveCart/containers/reducers';
import FloatingCart from '../Common/FloatingCart/containers/reducer';


const allReducers = combineReducers({
    CustomizeOrder,
    AddressValidationPage,
    CheckoutPage,
    ReviewOrderPage,
    Confirmation,
    SaveCartPage,
    FloatingCart,
    OptixCheckoutPage
});

const rootReducer = (state, action) => {
    if (action.type === "CLEAR_GLOBAL_STORE") {
        state = undefined;
    }
    return allReducers(state, action);
}

export default rootReducer;
